// extracted by mini-css-extract-plugin
export var li = "_ud-2";
export var ol = "_ud-1";
export var ul = "_ud-0";